export default "__VITE_ASSET__BihqlshT__"